import { render } from "./Document.vue?vue&type=template&id=415618e4"
import script from "./Document.vue?vue&type=script&lang=js"
export * from "./Document.vue?vue&type=script&lang=js"

import "./Document.vue?vue&type=style&index=0&id=415618e4&lang=css"

import exportComponent from "/Users/lianyue/Project/vue-upload-component/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__